import React from 'react';

const RelatedCourses = ({relatedCourses}) => {
  // Sample related courses
  // const relatedCourses = [
  //   {
  //     id: 1,
  //     title: "The Philosophy of Beauty",
  //     duration: "6 hours",
  //     instructor: "Emma Johnson",
  //     image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
  //   },
  //   {
  //     id: 2,
  //     title: "Skincare Product Formulation",
  //     duration: "8 hours",
  //     instructor: "Michael Chen",
  //     image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",

  //   },
  //   {
  //     id: 3,
  //     title: "Beauty Business Management",
  //     duration: "10 hours",
  //     instructor: "Rachel Adams",
  //     image: "https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60"
  //   },
  //   {
  //     id: 2,
  //     title: "Skincare Product Formulation",
  //     duration: "8 hours",
  //     instructor: "Michael Chen",
  //     image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",

  //   },
  //   {
  //     id: 2,
  //     title: "Skincare Product Formulation",
  //     duration: "8 hours",
  //     instructor: "Michael Chen",
  //     image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",

  //   },
  //   {
  //     id: 2,
  //     title: "Skincare Product Formulation",
  //     duration: "8 hours",
  //     instructor: "Michael Chen",
  //     image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",

  //   },
  // ];

  return (
    <>
    
    {
      relatedCourses && 
        <div style={{height:'100vh',overflowY:'auto'}}>
      <h6 className="mb-3">Recommended Courses</h6>
      
      {relatedCourses.map((course,Index) => (
        <div key={Index} className="related-course-card mb-3">
          <img 
            src={`${process.env.REACT_APP_BUCKET_URL}${course.thumbnail}`}
            alt={course.title} 
            className="related-course-image"
          />
          <div className="related-course-info">
            <p className='related-course-type'>Courses</p>
            <h6 className='related-course-title'>{course.title}</h6>

            <p className='related-course-view'>Total 15,000 views</p>
            {/* <p className="mb-0"><small><i className="bi bi-clock me-1"></i>{course.duration}</small></p> */}
          </div>
        </div>
      ))}
    </div>
    }
  </>
  );
};

export default RelatedCourses;